<input type="file" (change)="fileSelected($event)" #fileUpload>
<app-item class="half-column-gap" (click)="fileUpload.click()">
	<app-item-value value="Choose file"></app-item-value>
	<app-svg-icon name="add-circle-outline"></app-svg-icon>
</app-item>